import { Command, addCandidateNote } from '@nextforce/api'
import { t } from 'app/i18l'
import { CallOutCoverageScreenProps } from 'home/stack/types'
import React, { useCallback, useLayoutEffect } from 'react'
import { errorAlert } from 'shared/alerts'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderTitle } from 'shared/header/header_title'
import { useCallOutCoverage } from 'shifts/queries/callout_coverage'
import { usePerformCallOutAction } from 'shifts/queries/perform_action'
import { CallOutConverageView } from './views'

export function CalloutCoverageScreen({
  navigation,
  route,
}: CallOutCoverageScreenProps) {
  const callOutCoverageQuery = useCallOutCoverage(route.params, true)

  useLayoutEffect(() => {
    showHeaderTitle(
      navigation,
      callOutCoverageQuery.data?.title ?? t('callOutCoverageScreenTitle')
    )
  }, [callOutCoverageQuery.data?.title, navigation])

  const callOutMutation = usePerformCallOutAction(route.params)

  const onButtonPress = useCallback(
    async (command: Command, note?: string) => {
      if (command.type === 'action') {
        try {
          await callOutMutation.mutateAsync(
            addCandidateNote(command.action, note)
          )
        } catch (err: any) {
          errorAlert(err, t('callOutCoverActionErrorTitle'))
        }
      }
    },
    [callOutMutation]
  )

  return (
    <StatusBoundary
      isLoading={callOutCoverageQuery.isLoading}
      error={callOutCoverageQuery.error}
    >
      <CallOutConverageView
        callOutCoverageData={callOutCoverageQuery.data}
        onButtonPress={onButtonPress}
      />
    </StatusBoundary>
  )
}
